module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scene"
  }, [_c('flash-swf', {
    attrs: {
      "attributes": _vm.attr,
      "flashvars": _vm.flashvars
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f44e8c12","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Scene/Scene.vue
// module id = 411
// module chunks = 0